import React, { Component } from "react";
import classNames from "classnames";
import { Field } from "formik";
import { string } from "prop-types";

import MultiSelect from "pages/_components/fields/MultiSelect";

class FormikMultiSelect extends Component {
    static propTypes = {
        valueKey: string,
        name: string.isRequired,
        formGroupClassName: string,
    };

    static defaultProps = {
        valueKey: "value",
        formGroupClassName: "",
    };

    handleSelect = ({ form, field }, option) => {
        const { valueKey } = this.props;
        const { name, value = [] } = field;

        form.setFieldValue(name, [...value, option[valueKey]]);
    };

    handleDelete = ({ form, field }, option) => {
        const { valueKey } = this.props;

        form.setFieldValue(
            field.name,
            field.value.filter((selectedOption) => selectedOption !== option[valueKey]),
        );
    };

    render() {
        const { name, formGroupClassName } = this.props;

        return (
            <Field name={name}>
                {(formProps) => {
                    const { field, form } = formProps;
                    const { touched, errors } = form;
                    const hasError = touched[field.name] && errors[field.name];

                    return (
                        <div
                            className={classNames("form-group", formGroupClassName, {
                                "has-error": hasError,
                            })}>
                            <MultiSelect
                                onSelect={(option) => this.handleSelect(formProps, option)}
                                onDelete={(option) => this.handleDelete(formProps, option)}
                                values={field.value}
                                {...this.props}
                            />
                        </div>
                    );
                }}
            </Field>
        );
    }
}

export default FormikMultiSelect;
